/**
 * Deep Teal brand palette, mirrored from the Flutter app's `lib/core/theme/app_colors.dart` (the source of truth).
 * Change a value there first, then here, so the admin and the app never drift apart.
 */
export const brand = {
  /** Brand color and app background (Deep Teal). */
  background: '#023E41',
  backgroundDeep: '#012B2D',
  surfaceLow: '#064649',
  surface: '#0A4F52',
  surfaceHigh: '#145F61',
  surfaceHighest: '#1C6B6C',
  divider: '#24706F',
  outlineVariant: '#1A6062',

  /** Interactive accent: filled buttons, selected states, focus rings. Pair with [onPrimary]. */
  primary: '#14B8A6',
  onPrimary: '#00201F',
  primaryLight: '#5EEAD4',
  /** Tonal fill that carries white content; also the light-mode primary (AA with white text). */
  primaryContainer: '#0F766E',
  onPrimaryContainer: '#E6FFFB',
  accentBlue: '#38BDF8',

  success: '#4CAF50',
  danger: '#FF6B6B',
  muted: '#7FA9A7',
  gold: '#F5B800',
  live: '#FF2D55',
  diamond: '#38BDF8',
  giftPink: '#EC4899',

  textPrimary: '#FFFFFF',
  textSecondary: '#B5CFCD',
} as const;

/** Tonal teal gradient used on headers and CTA bars; carries white text. */
export const brandGradient = `linear-gradient(225deg, ${brand.primaryContainer} 0%, #075E61 100%)`;

/** Roboto is the Material 3 default the app renders with; the variable font is bundled (no third-party request). */
export const fontFamily =
  "'Roboto Variable', Roboto, system-ui, -apple-system, 'Segoe UI', 'Helvetica Neue', Arial, 'Noto Sans', sans-serif, 'Apple Color Emoji', 'Segoe UI Emoji'";

export type ResolvedMode = 'light' | 'dark';

/** Browser chrome color (`<meta name="theme-color">`) per mode. */
export const themeColor: Record<ResolvedMode, string> = { dark: brand.background, light: '#F3F8F8' };
